export default __webpack_public_path__ + "static/media/single_conv_hybrid_topology_reduced.75e87aa1.png";